import React from 'react'
import { useTranslate } from 'react-polyglot'
import { v4 as uuidv4 } from 'uuid'

import './formField.scss'

// console.log(input)
const createRenderer = render => ({
	input,
	meta,
	label,
	description,
	disabled = false,
	button,
	...rest
}) => {
	const t = useTranslate()
	const id = uuidv4()

	const showError =
		meta.error &&
		meta.dirty &&
		// meta.touched &&
		!(meta.active && !meta.touched)

	return (
		<div
			className={[
				'c-form__fieldwrap',
				showError ? 'has-error' : '',
				meta.active ? 'is-active' : '',
			].join(' ')}
		>
			{/* <pre>{JSON.stringify(meta, 0, 2)}</pre> */}
			{render(input, label, description, disabled, id, rest)}

			{button && <div className="c-form__button">{button}</div>}

			{showError && (
				<span className="c-form__error">
					{t(`errors.${meta.error}`)}
				</span>
			)}
		</div>
	)
}

export default createRenderer
